import React, { useState } from 'react';
import { useMutation } from '@common/hooks';
import { createMessage } from 'works/legacy/lib/message-helper';
import { Button } from '@common/components';
import { PERFORM_EXTENSION_OFFER_ACTION_MUTATION } from '@working-experience/graphql';

export function ExtensionOfferActionAccept({
  extensionOfferId,
  disabled,
}: {
  extensionOfferId: string;
  disabled?: boolean;
}) {
  const [loading, setLoading] = useState(false);

  const [performAction] = useMutation(PERFORM_EXTENSION_OFFER_ACTION_MUTATION, {
    onCompleted() {
      createMessage(
        'success',
        'Extension Offer accepted, assignment has been updated.'
      );
    },
    onError: () => {
      setLoading(false);
      createMessage(
        'error',
        'Extension Offer could not be accepted. Please try again or contact your hiring partner.'
      );
    },
    refetchQueries: ['CandidateAssignmentQuery'],
  });

  const onClick = () => {
    setLoading(true);
    performAction({
      variables: {
        extensionOfferId: extensionOfferId,
        input: {
          action: 'accept',
        },
      },
    });
  };

  return (
    <Button
      kind="primary"
      loading={loading}
      disabled={disabled}
      onClick={onClick}
    >
      Accept Offer
    </Button>
  );
}
